//-- Copyright (c) 2021 TMT Insights Group, LLC
import { DashboardConfig } from '@/__configs/config_types';

const dashboardConfig: DashboardConfig = {
  statusCards: [
    {
      name: 'Awaiting Assets',
      status: 'awaiting_assets',
      color: 'default',
      filter: ['awaiting_assets'],
      icon: 'clock'
    },
    {
      name: 'QC',
      status: 'qc',
      color: 'warning',
      icon: 'timelapse',
      filter: ['qc']
    },
    {
      name: 'Screening',
      status: 'screening',
      color: 'info',
      icon: 'search',
      filter: ['screening']
    },
    {
      name: 'Packaging',
      status: 'packaging',
      color: '#dd2277',
      filter: ['packaging'],
      icon: 'clock_progress'
    },
    {
      name: 'Complete',
      status: 'complete',
      color: 'success',
      ignoreOnPieChart: true,
      filter: ['complete'],
      icon: 'check'
    }
  ],
  customizeDashboard: true,
  graphList: [
    {
      id: 'open-job-status',
      checked: true
    },
    {
      id: 'completed-jobs',
      checked: true
    },
    {
      id: 'recent-tasks',
      checked: true
    },
    {
      id: 'daily-reports',
      checked: true
    }
  ],
  graphSettings: {
    'completed-jobs': {
      displayed_job_types: ['edit', 'delivery', 'tech_review']
    }
  },
  maximumGraphsPerRow: 3,
  chartColors: ['#BC13FE', '#FF1493', 'info', '#39FF14']
};

export default dashboardConfig;
